import Image from "next/image";

export const Logo = (properties: { className?: string | undefined }) => {
  const { className } = properties;
  return <Image alt="DFS" className={className} height={100} priority src="/dfs-logo.png" width={100} />;
};
